<div
  *ngIf="_cardDetails"
  [ngClass]="{ mini: miniSize, middle: midSize }"
  class="card card--front"
>
  <div class="card__header">
    <img
      alt="chip"
      class="chip"
      src="/assets/images/card-logos/card-chip.png"
    />
    <img
      *ngIf="logoUrl"
      [alt]="_cardDetails.brand"
      [src]="logoUrl"
      class="card__logo"
    />
    <i
      (click)="deleteCard()"
      *ngIf="allowRemoveCard"
      class="pi pi-times red"
      style="color: #f36"
    ></i>
  </div>
  <div class="card__number">XXXX XXXX XXXX {{ _cardDetails.last4 }}</div>
  <div class="card__footer">
    <div class="card__expiry-date">
      <span>EXPIRES</span><span>{{ MM }}/{{ YY }}</span>
    </div>
    <div class="card__cvv">
      <div class="card__cvv-label">CVV</div>
      <div class="card__cvv-value text-right">***</div>
    </div>
  </div>
</div>
